<template>
  <b-datepicker
    v-model="computedValue"
    :placeholder="placeholder"
    icon-pack="cls"
    :icon="icon"
    :min-date="minDate"
    :max-date="maxDate"
    :disabled="disabled"
    :inline="inline"
    :loading="loading"
    :range="range"
    :position="position"
    :years-range="yearsRange"
    :locale="locale"
    :date-formatter="dateFormatter"
    :mobile-native="mobileNative"
    :mobile-modal="mobileModal"
  >
    <template #trigger="props">
      <slot name="trigger" v-bind="props" />
    </template>
  </b-datepicker>
</template>

<script>
import { Locale } from '@/modules/core/app/constants/Locale';
import { FormComputedValueMixin } from '@/modules/core/form/mixins/FormComputedValueMixin';
import Lang from '@/modules/core/app/services/Lang';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'DatepickerView',
  slotsDefinition: {
    trigger: { props: Object }
  },
  mixins: [FormComputedValueMixin],
  props: {
    value: {
      type: [String, Date],
      default: null
    },
    placeholder: {
      type: String,
      default: () => Lang.t('core.select-date'),
      required: false
    },
    icon: {
      type: String,
      default: 'cls-calendar'
    },
    minDate: {
      type: [String, Date],
      required: false
    },
    maxDate: {
      type: [String, Date],
      required: false,
      default: () => new Date()
    },
    disabled: {
      type: Boolean,
      default: false
    },
    inline: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    range: {
      type: Boolean,
      default: false
    },
    position: {
      type: String
    },
    yearsRange: {
      type: Array,
      default: () => [-100, 100]
    },
    locale: {
      type: String,
      default: Locale.ENGLISH_CANADA
    },
    dateFormatter: {
      type: Function
    },
    mobileNative: {
      type: Boolean,
      default: true
    },
    mobileModal: {
      type: Boolean,
      default: false
    }
  }
};
</script>
